import { NgClass, NgForOf, NgIf } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow, MatHeaderRowDef,
  MatRow, MatRowDef,
  MatTable
} from '@angular/material/table';
import { LoadingComponent } from '../../loading/loading.component';
import { RippleDirective } from '../../ripple.directive';
import { MessageNotificationService } from '../../shared/services/message-notification.service';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';
import { DataCleanerService } from '../data-cleaner.service';
import { IColumns } from '../models/columns-model';
import { ISearchResults } from '../models/search-results.model';

@Component({
  selector: 'app-results-table',
  templateUrl: './results-table.component.html',
  imports: [
    LoadingComponent,
    NgClass,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCell,
    MatCellDef,
    NgIf,
    MatHeaderRow,
    MatRow,
    MatRowDef,
    MatHeaderRowDef,
    RippleDirective,
    NgForOf
  ],
  styleUrls: ['./results-table.component.scss']
})
export class ResultsTableComponent implements OnInit {
  @Input() isLoading: boolean;
  @Input() isCandidate: boolean;
  @Input() searchResults: ISearchResults;
  @Input() columns: IColumns[];
  @Input() showResultsTable: boolean;
  @Input() currentSearchId: string;
  columnTitles: string[];

  constructor(
      private dataCleanerService: DataCleanerService,
      private messageNotificationService: MessageNotificationService,
      private confirmationDialogService: ConfirmationDialogService
  ) {
  }

  ngOnInit(): void {
    this.columnTitles = this.columns.map(col => col.name);
  }

  showCsvExportButton(): boolean {
    return !!this.searchResults?.data;
  }

  cellHasNoData(row: any, column: any): boolean {
    return row[column.name] === 0;
  }

  getCSV() {
    const searchId = this.currentSearchId || this.searchResults?.searchId;
    if (!this.searchResults || this.isLoading) {
      alert('Report running or no data to export');
    }
    this.isLoading = true;
    this.dataCleanerService.getCSV(searchId, this.isCandidate).subscribe((data: any) => {
      console.log(data?.path);
      window.open(data?.path);
      this.isLoading = false;
    });
  }

  confirmCreateTearSheet(row: any, column: any) {
    console.log(row, column);
    const numberOfEntities = row[column.name];
    let entityName = this.isCandidate ? 'candidate' : 'contact';
    entityName = numberOfEntities > 1 ? entityName.concat('s') : entityName;
    const message = 'A tear sheet will be created with <span class="green">' + numberOfEntities + '</span> ' + entityName;
    this.confirmationDialogService.confirm('Confirm Tear Sheet', message).then((confirmed) => {
      this.createTearSheet(row, column, confirmed.hotname);
    }).catch(() => console.log('CANCELLED'));
  }

  createTearSheet(row, column, hotListName) {
    this.isLoading = true;
    const searchId = this.currentSearchId || this.searchResults?.searchId;
    this.dataCleanerService.createTearSheet(searchId, row.group, column.name, hotListName, this.isCandidate)
        .subscribe((data: any) => {
          if (data.success) {
            this.messageNotificationService.success(data.msg + ' - ' + data.name);
          } else {
            this.messageNotificationService.error(data.msg);
          }
          this.isLoading = false;
        }, error => {
          this.isLoading = false;
          this.messageNotificationService.error('An error occurred while creating tearsheet', error.message);
        });
  }
}
